import { UserCreateForm, type UserFormCreateValues } from '../userCreateForm';
import { useCreateUser } from '@entities/user';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { showNotification } from '@shared/utils';
import { ROLES } from '@shared/constants';
import { useShowMe } from '@entities/auth';

export const UserCreate = () => {
  const { data: me } = useShowMe();

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate: createUser, isPending } = useCreateUser();

  const handleSubmit = (values: UserFormCreateValues) => {
    createUser(
      {
        email: values.email,
        role: values.role,
        profile: {
          firstName: values.firstName,
          lastName: values.lastName,
          phone: values.phone,
        },
        companyId: Number(values.companyId) || undefined,
        password: values.password || '',
        password_confirmation: values.passwordConfirmation || '',
      },
      {
        onSuccess: data => {
          queryClient.invalidateQueries({
            queryKey: [QueryKey.GET_USERS_WITH_PAGINATION],
          });

          navigate(`/user-list/${data?.id}`);
        },
        onError: error => {
          showNotification({
            error,
            message:
              error.response?.data.message ||
              'Ошибка при создании пользователя',
            variant: 'error',
          });
        },
      }
    );
  };

  const handleClose = () => {
    navigate('/');
  };

  return (
    <UserCreateForm
      isAdmin={me?.role.name === ROLES.ADMIN}
      isLoading={isPending}
      isDisabled={isPending}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
